export const SKETCH_CATEGORIES = [
  { id: 'effects', name: 'Effects', icon: 'sparkles', description: 'Image & video processing' },
  { id: 'generators', name: 'Generators', icon: 'grid', description: 'Standalone generative art' },
  { id: 'particles', name: 'Particles', icon: 'flame', description: 'Particle systems' },
  { id: 'audio-reactive', name: 'Audio', icon: 'music', description: 'Sound-driven visuals' },
  { id: '3d', name: '3D', icon: 'box', description: 'Three.js 3D scenes' },
  { id: 'interactive', name: 'Interactive', icon: 'mouse-pointer', description: 'Mouse & keyboard driven' },
  { id: 'typography', name: 'Typography', icon: 'type', description: 'Text-based generative' },
  { id: 'utilities', name: 'Utilities', icon: 'wrench', description: 'Helper effects' },
  { id: 'fractals', name: 'Fractals', icon: 'snowflake', description: 'Mathematical art' },
] as const;

export type SketchCategoryId = (typeof SKETCH_CATEGORIES)[number]['id'];
